import Vue from 'vue';
import VueRouter from 'vue-router';

import Base from './pages/Base';
import Default from './modules/root/login/components/Default';
import Booking from './pages/Booking';
import AddressDetailsDashboard from './pages/AddressDetailsDashboard';
import RegisterPage from './modules/root/register/components/RegisterPage';
import ForgotPasswordPage from './modules/root/forgotpassword/components/ForgotPasswordPage';
import ResetPasswordPage from './modules/root/resetpassword/components/ResetPasswordPage';
import EmailVerificationSuccess from './pages/EmailVerificationSuccess';
import PageNotFound from './pages/PageNotFound';
import Sitemap from './pages/Sitemap';

import BookService from './modules/booking/home/components/BookService';
import BookingFormDetails from './modules/booking/form/components/BookingFormDetails';
import MyProfile from './modules/booking/profile/components/MyProfile';
import BookingHistory from './modules/booking/history/components/BookingHistory';
import FrequentlyAsked from './modules/booking/faq/components/FrequentlyAsked';
import RequestCancellation from './modules/booking/requestcancellation/components/RequestCancellation';
import CsoBookingManagement from './modules/booking/cso/components/CsoBookingManagement';

// Example component lazy loading for faster initial page load time
// const RegisterPage = () => import('./pages/RegisterPage');

Vue.use(VueRouter);

export default new VueRouter({
    routes: [
        {
            path: '/',
            component: Base,
            meta: {
                requiresVisitor: true
            },
            children: [
                {
                    path: '',
                    redirect: 'login',
                    meta: {
                        title: 'Login'
                    },
                },
                { 
                    path: 'login',
                    component: Default,
                    name: 'login',
                    meta: {
                        title: 'Login'
                    },
                },
                {
                    path: 'register',
                    component: RegisterPage,
                    name: 'registration',
                    meta: {
                        title: 'Registration'
                    },
                },
                {
                    path: 'forgotpassword',
                    component: ForgotPasswordPage,
                    name: 'forgotpassword',
                    meta: {
                        title: 'Forgot Password'
                    },
                },
                {
                    path: 'resetpassword',
                    component: ResetPasswordPage,
                    name: 'resetpassword'
                }
          ]
        },
        // { path: '/login', component: Default, name: 'login', meta: { requiresVisitor: true } },
        // { path: '/register', component: RegisterPage, name: 'registration', meta: { requiresVisitor: true } },
        {
            path: '/addressdetailsdashboard',
            component: AddressDetailsDashboard,
            meta: {
                requiresCouncil: true
            },
        },
        {
            path: '/booking',
            component: Booking,
            children: [
                {
                    path: '',
                    redirect: 'home',
                    meta: {
                        requiresAuth: true,
                        title: 'Home'
                    },
                },
                {
                    path: 'home',
                    component: BookService,
                    meta: {
                        requiresAuth: true,
                        title: 'Home'
                    },
                },
                {
                    path: 'form',
                    component: BookingFormDetails,
                    meta: {
                        requiresAuth: true,
                        title: 'Booking'
                    },
                },
                {
                    path: 'my-profile',
                    component: MyProfile,
                    meta: {
                        requiresAuth: true,
                        title: 'Profile'
                    },
                },
                {
                    path: 'history',
                    component: BookingHistory,
                    meta: {
                        requiresAuth: true,
                        title: 'Booking History'
                    },
                },
                {
                    path: 'faq',
                    component: FrequentlyAsked,
                    meta: {
                        title: 'FAQ'
                    },
                },
                {
                    path: 'request-cancellation',
                    component: RequestCancellation,
                    meta: {
                        requiresAuth: true,
                        title: 'Request Cancellation'
                    },
                },
                {
                    path: 'queued-bookings',
                    component: CsoBookingManagement,
                    meta: {
                        requiresAuth: true,
                        title: 'CSO Bookings Management'
                    },
                }
            ]
        },
        {
            path: '/email-verification-success',
            component: EmailVerificationSuccess,
            name: 'email-verification-success'
        },
        {
            path: '/site-map',
            component: Sitemap,
            name: 'site-map'
        },
        // If nothing matches the specified route segment
        { path: '*', component: PageNotFound }
    ]
});